import { render, staticRenderFns } from "./ReviewBarAmerican.vue?vue&type=template&id=059aa172&scoped=true"
import script from "./ReviewBarAmerican.vue?vue&type=script&lang=js"
export * from "./ReviewBarAmerican.vue?vue&type=script&lang=js"
import style0 from "./ReviewBarAmerican.vue?vue&type=style&index=0&id=059aa172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059aa172",
  null
  
)

export default component.exports